"use client";

import { UserPolicy } from "../../../../lib/types/enums/UserPolicy";
import { useUserPolicy } from "../useUserPolicy";

export const useIsBlockedFromCommunity = (): boolean =>
  useUserPolicy(UserPolicy.blockedFromCommunity);
